








































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { maskCPFCNPJ } from '@/utils/common'
import { RegistroServico, Servico, TITULO_SERVICO } from '@/components/Suporte/diagnosticoUsuarioEngine'

@Component
export default class CardServicoDiagnostico extends Vue {
  @Prop({ required: true }) servico!: Servico
  @Prop({ required: true }) registros!: RegistroServico[]
  @Prop({ required: true }) camposDivergentes!: Set<string>
  @Prop({ default: false }) isMaster!: boolean

  get titulo() {
    return TITULO_SERVICO[this.servico]
  }

  get db() {
    return this.servico === 'seguranca' ? 'MongoDB' : 'SQL Server'
  }

  get corDb() {
    return this.servico === 'seguranca' ? '#43A047' : '#2652A3'
  }

  get temRegistros() {
    return this.registros && this.registros.length > 0 && this.registros.some(r => r.status === 'encontrado')
  }

  get status() {
    if (!this.registros || this.registros.length === 0) return 'nao_encontrado'
    if (this.registros.some(r => r.status === 'encontrado')) return 'encontrado'
    if (this.registros.some(r => r.status === 'indisponivel')) return 'indisponivel'
    return 'nao_encontrado'
  }

  get labelStatus() {
    if (this.status === 'indisponivel') return 'Indisponível'
    if (this.status === 'nao_encontrado') return 'Não encontrado'
    const n = this.registros.filter(r => r.status === 'encontrado').length
    return n > 1 ? `Encontrado (${n})` : 'Encontrado'
  }

  get corStatus() {
    if (this.status === 'indisponivel') return '#FB8C00'
    if (this.status === 'nao_encontrado') return '#9E9E9E'
    return this.isMaster ? '#8E24AA' : '#43A047'
  }

  get primeiroErro() {
    const r = this.registros.find(x => x.status === 'indisponivel')
    return r && r.erro
  }

  cssLinha(campo: string) {
    return this.camposDivergentes.has(campo) ? 'diverge' : ''
  }

  maskDocumento(value: string) {
    return maskCPFCNPJ(value)
  }
}
